// ============================================================
// web/src/features/devis/LecturePlanMatiere.jsx — LA MATIÈRE ET LE BRUT,
// À CÔTÉ DU PLAN.
// ------------------------------------------------------------
// Ce bloc vivait dans la colonne de droite du chiffrage, sous le titre
// « Lecture de plan — matière et brut ». Il est monté CONTRE LE DESSIN le
// 16 septembre 2026, sur l'idée de Thibaud, pour deux raisons :
//
//  - il DIT ce qu'il est : la nuance, la densité, le prix au kilo et la
//    forme du brut viennent de la lecture du plan et du référentiel — pas
//    d'une décision du deviseur (c'est la correction du 21 août). Sa place
//    est donc avec le plan et l'identité de la pièce, pas en face de la
//    gamme ;
//  - il remplit le vide. Mesuré le 16 septembre sur le devis 2026-09-040 :
//    la fiche faisait 442 px de haut contre 928 px pour le dessin, et la
//    colonne de droite du chiffrage 742 px contre 2 880 px à gauche.
//    Après déplacement : 0 px de vide à droite de la gamme, et la page
//    passe de 6 114 px à 4 991 px de haut.
// ============================================================
import PieceMaterial from './PieceMaterial.jsx';
import PreChiffrage from './PreChiffrage.jsx';
import Barriere from '../../ui/Barriere.jsx';

export function LecturePlanMatiere({
  piece, result, disabled, onChange, sources, materiaux, onRecharger,
}) {
  return (
    <section className="colonne colonne--retenu" aria-label="Lecture de plan — matière et brut">
      <p className="colonne__titre">Lecture de plan — matière et brut</p>
      <p className="field__hint">
        Relevé sur le plan et complété par le référentiel.
        <strong> Tout se modifie ici</strong> : ce que vous laissez tel quel part
        sur l’offre.
      </p>

      {/* 5. LA MATIÈRE — UN SEUL ENDROIT : nuance, densité, prix,
       forme du brut, cotes, transport. Le prix matière se
       changeait à trois endroits différents, sans qu'aucun
       écran ne dise lequel gagnait. */}
      <Barriere zone="Matière">
        <PieceMaterial
          piece={piece}
          onChange={onChange}
          disabled={disabled}
          sources={sources}
          materiaux={materiaux}
          onRecharger={onRecharger}
        />
        {piece.is_purchase ? null : (
          <>
      <PreChiffrage
        piece={piece}
        result={result}
        disabled={disabled}
        onChange={onChange}
        partie="brut"
      />
      {/* ── « CE QUI PRÉVAUT » A REJOINT LES RÉGLAGES ──
          Il vivait ici, sous le brut, dans l'ordre du
          raisonnement : on lit la matière, puis la forme et
          le volume, puis ce qu'on retient comme montant.
          Cet ordre était juste — et ces trois champs sont
          remplis dans moins d'un devis sur cinq, alors
          qu'ils occupaient la vue sur TOUTES les pièces.

          Ils sont dans le repli « Réglages de cette pièce »,
          juste au-dessus du prix, avec les cinq autres
          champs de même nature. Le repli s'ouvre tout seul
          dès qu'un montant y est posé, et son intitulé le
          NOMME : on ne cache jamais un montant qui part
          chez le client. */}
          </>
        )}
      </Barriere>

    </section>
  );
}

export default LecturePlanMatiere;
